<template>
  <div id="space" class="compre">

      <img src="../assets/logomarca.png" class="logo" alt="Empório das Marcas" />

      <p id="subs">Compre em qualquer lugar</p>
      <p id="subs">Escolha abaixo qual desejar:</p>

      <div>
          <a href="https://g.page/EmporiodasMarcas?share" target="_blank">
          <div id="bloco">
              <p id="name_bloco">Loja Física</p>
          </div>
          </a>
          <a href="https://api.whatsapp.com/send?phone=5584999337331" target="_blank">
          <div id="bloco">
              <p id="name_bloco">WhatsApp</p>
          </div>
          </a>
          <!-- <a href="https://api.whatsapp.com/send?phone=5584998918064" target="_blank">
          <div id="bloco">
              <p id="name_bloco">WhatsApp - 02</p>
          </div>
          </a> -->
          <a href="https://instagram.com/emporiodasmarcas_" target="_blank">
          <div id="bloco">
              <p id="name_bloco">Instagram</p>
          </div>
          </a>
          <a href="https://emporiodasmarcas.com.br" target="_blank">
          <div id="bloco">
              <p id="name_bloco">WebSite</p>
          </div>
          </a>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
#space{
    margin: 10px auto;
    width: 50%;
}

#bloco{
    padding: 20px 0px;
    margin: 20px 10px;
    border-width: 1px;
    border: 1px solid burlywood;
    border-radius: 10px;
}

#subs{
    color: #4e4e4e;
    margin-top: 10px;
}

#bloco:hover{
    background-color: burlywood;
}

#name_bloco{
    font-size: 20px;
    font-weight: 800;
    color: #000;
}

.compre .logo{
    height: 140px;
    object-fit: contain;
}

</style>